export enum EnrollModalType {
  ENROLL = 'ENROLL',
  ERROR = 'ERROR',
}
